<template>
<div>
    <el-table
        :data="recordList"
        :show-header="false"
        cell-class-name="record-cell"
        class="record-table"
        style="width: 100%">
        <div slot="empty">
            <div class="empty_wrapper">
                No Records added yet
                <el-button @click="$emit('add-new')"> 
                    <span class="button-central">
                        <i>&#43;</i> Add New
                    </span>
                </el-button>
            </div>
        </div>
        <el-table-column  width="145">
            <template slot-scope="scope">
                <div class="attach-file ml-2">
                    <span class="attach-category">{{ getCategoryName(scope.row.category_id) }}</span>
                </div>
            </template>
        </el-table-column>
        <el-table-column  width="200">
            <template slot-scope="scope">
                <div class="attach-name">
                    {{ scope.row.name }}
                </div>
            </template>
        </el-table-column>
        <el-table-column >
            <template slot-scope="scope">
                <div class="attach-comment" v-if="!scope.row.comment">
                    <el-button size="small" @click="openCommentDialog(scope.row)">
                        <div class="button-set">
                            <i class="el-icon-plus"></i>
                            Add Details
                        </div>
                    </el-button>
                </div>
                <div class="attach-comment" v-else>
                    <div class="comment">
                        <TextTruncate :text="scope.row.comment" :max-length="200" style="margin-bottom: 1px;"></TextTruncate>
                        <span
                            class="edited-by"
                            v-if="scope.row.modified_by && getUserType !== 'observer'"
                            @click="getRevisionHistory('record', scope.row.id)">
                            (Edited by {{getUploader(scope.row.modified_by) || scope.row.created_name}})
                        </span>
                    </div>
                    <el-button v-if="getUserType !== 'observer'">
                        <div class="button-set" @click="openCommentDialog(scope.row)">
                            <EditIcon height="11"></EditIcon>
                            Edit Details
                        </div>
                    </el-button>
                </div>
            </template>
        </el-table-column>
        <el-table-column width="200">
            <template slot-scope="scope" >
                <div class="attach-date" v-if="getUploader(scope.row.created_by) && getUserType !== 'observer'">
                    <span>
                        <i>Added by {{ getUploader(scope.row.created_by) }}</i>  - {{ formatDate(scope.row.created) }}
                        <br>
                    </span>
                    <span v-if="scope.row.modified_time">
                        <i>Last updated</i> - {{ formatDate(scope.row.modified_time) }}
                    </span>
                </div>
                <div class="attach-date" v-if="getUserType === 'observer'">
                    <span v-if="scope.row.modified_time" class="observer">
                        Last updated {{ formatDate(scope.row.modified_time) }}
                    </span>
                </div>
            </template>
        </el-table-column>
    </el-table>
    <el-dialog
          :visible.sync="showHistory"
          :append-to-body="true"
          class="send-now-modal record-history-dialog"
          @close="closeCommentDialog"
          :close-on-click-modal="false"
          width="70%">
          <div slot="title">Edit History</div>
           <div class="loading-content" v-if="loadHistory">
                <LoadSpinnerIcon type="primary"></LoadSpinnerIcon>
                Loading Revision History
          </div>
          <div v-else-if="historyObj">
            <div
                v-for="(history, index) in historyObj.history"
                :key="index"
                class="record-history-body">
                    <div class="history-header">
                        <ImgPlaceholderIcon></ImgPlaceholderIcon>
                        <span class="name">{{history.modified_name || history.created_name}}</span>
                        <div class="oval"></div>
                        <span class="date">{{formatDateTime(history.modified_time) || formatDateTime(history.created)}}</span>
                    </div>
                    <div class="history-comment">{{history.comment}}</div>
            </div>
          </div>
          <div v-else style="color:red">
              Sorry there was error getting revision history
          </div>
          <div class="footer">
            <el-button
                type="primary"
                size="small"
                class="send-button"
                @click="showHistory = false">
                    Close
            </el-button>
          </div>
    </el-dialog>
    <el-dialog
          :visible.sync="addEditComment"
          :append-to-body="true"
          class="send-now-modal record-dialog"
          @close="closeCommentDialog"
          :close-on-click-modal="false"
          v-if="addEditComment"
          width="70%">
          <div slot="title">
              {{ editObj.comment ? 'Edit' : 'Add' }} {{ getCategoryName(editObj.category_id) }} Details
          </div>
          <div>
              <div class="display-row">
                  <div class="category-info">
                      <span class="category-name">{{ editObj.name }}</span>
                      <span class="time">{{ formatDateTime(editObj.created) }}</span>
                  </div>
                  <div class="attach-file">
                    {{ getCategoryName(editObj.category_id) }}
                  </div>
              </div>
              <div class="input-row">
                    <label>{{ editObj.comment ? 'Edit' : 'Add' }}  Details</label>
                    <el-input
                        type="textarea"
                        :rows="19"
                        size="small"
                        placeholder="Please input"
                        :maxlength="5000"
                        v-model="comment">
                    </el-input>
                    <div class="character-left">
                        {{ 5000 -  comment.length }} characters left
                    </div>
                    <span class="error-text" v-if="comment === '' && showError">
                        Please enter details
                    </span>
              </div>
          </div>
          <div class="footer">
              <LoadingButton
                    type="primary"
                    size="small"
                    class="send-button"
                    @click="update"
                    :loading="updating"
                    :loaded="updated">
                Done
            </LoadingButton>
            <el-button type="text" size="small" class="cancel-button" @click="addEditComment = false">
                Cancel
            </el-button>
          </div>
    </el-dialog>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CardTable from '../component/table'
import EditIcon from '@/module/add/icons/Edit.vue'
import ImgPlaceholderIcon from '@/module/add/icons/ImgPlaceholder.vue'
import LoadingButton from '@/module/component/LoadingButton.vue'
import TextTruncate from '@/module/component/TextTruncate'
import LoadSpinnerIcon from '@/module/component/icon/LoadSpinner'



export default {
    name: 'patient-file-card-table',
    extends: CardTable,

    props: {
        patient: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            addEditComment: false,
            editObj: null,
            comment: '',
            updating: false,
            updated: false,
            showError: false,
            historyObj: {},
            showHistory: false,
            loadHistory: false
        }
    },

    methods: {
        ...mapActions('provider', [
            'updateRecord',
            'revisionHistory',
        ]),
        getCategoryName(categoryId) {
            const category = this.patientRecordCategories.find((category) => category.id === categoryId)
            if(category)
                return category.title
            return ''
        },
        getUploader(uploaderId) {
            if(this.getUser && this.getUser.id === uploaderId)
                return this.getUser.name
            if(this.getProviderList) {
                const provider = this.getProviderList.find(({ provider }) => provider === uploaderId)
                if(provider)
                    return provider.name
            }
            return null
        },
        openCommentDialog(editObj) {
            this.editObj = editObj
            this.comment = editObj.comment || ''
            this.updated = false
            this.showError = false
            this.addEditComment = true
        },
        closeCommentDialog() {
            this.editObj = null
            this.comment = ''
            this.addEditComment = false
        },
        update() {
            if(this.comment === '') {
                this.showError = true
                return
            }
            const updateObj = {
                comment: this.comment,
                modified_by: this.getUser.id,
                modified_time: Date.now()
            }
            this.updating = true
            this.updateRecord({
                patient: this.patient.id,
                provider: this.patientProviderProfileList[0].provider,
                id: this.editObj.id,
                previousObj: this.editObj,
                updateObj
            }).then((response) => {
                this.updating = false
                this.updated = true
                this.closeCommentDialog()
            })
        },
        getRevisionHistory(type, id) {
            this.showHistory = true
            this.loadHistory = true
            this.revisionHistory({
                type,
                id,
                patient: this.patient.id,
                provider: this.patientProviderProfileList[0].provider,
            }).then((response) => {
                this.historyObj = response.revision
                this.loadHistory = false
            })
        }
    },

    computed: {
        ...mapGetters('provider', [
            'getPatientRecords',
            'getPatientProviderProfileList',
            'getProviderList'
        ]),
        ...mapGetters('user', [
            'getUser'
        ]),
        ...mapGetters(['getUserType']),
        recordList() {
            return this.getPatientRecords(this.patient.id)
        },
        patientProviderProfileList() {
            return this.getPatientProviderProfileList(this.patient.id)
        },
        patientRecordCategories() {
            if(this.patientProviderProfileList && this.patientProviderProfileList.length == 1)
                return this.getContentKey('profile', this.patientProviderProfileList[0].profile, 'record_categories')
            return []
        }
    },

    components: {
        EditIcon,
        LoadingButton,
        TextTruncate,
        ImgPlaceholderIcon,
        LoadSpinnerIcon
    }

}
</script>

<style lang="scss" scoped>
@import './style.scss';

.attach-file {
    background-color: #fff1df;
    color: #e28816;
}
.ml-2 {
    margin-left: 2px;
}
.attach-name {
    font-weight: bold;
    color: #333333;
    line-height: 23px;
    word-break: break-word;
}
.comment {
    display: flex;
}
.character-left {
    font-size: 12px;
    color: #999999;
    margin-top: 3px;
}
.edited-by {
    color: #999;
    font-size: 12px;
    margin-left: 5px;
    cursor: pointer;
    white-space: nowrap;
}
.attach-comment {
    p{
        font-size: 12px;
        line-height: 18px;
        word-break: break-word;
    }
    .el-button {
        font-size: 10px;
        padding: 4px 8px;
        color: #2874e8;
        border: 1px solid #e2e2e2;
        // display: flex;
        // align-items: center;
        // justify-content: center;
        .button-set {
            display: flex;
            line-height: 12px;
            svg, i {
                margin-right: 2px;
            }
        }
    }
}
.attach-uploader {
    font-size: 12px;
    line-height: 16px;
    color: #828282;
    text-align: right;
    word-break: break-word;
}
.display-row {
    display: flex;
    margin-bottom: 16px;
    .category-info {
        flex-grow: 1;
        .category-name {
            display: block;
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            word-break: break-word;
        }
        .time {
            display: block;
            font-size: 12px;
            line-height: 18px;
            margin-top: 6px;
            color: #828282;
        }
    }
    .attach-file {
        min-width: 100px;
    }
}
.history-header {
    display: flex;
    align-items: center;
    .oval {
        height: 3px;
        width: 3px;
        margin-bottom: 2px;
        background-color: #666666;
        border-radius: 50%;
        margin-left: 8px;
        margin-right: 8px;
    }
    .name {
        font-size: 16px;
        font-weight: 600;
        color: #333333;
        margin-left: 11px;  
    }
    .date {
        font-size: 14px;
        color: #666666;
    }
}
.history-comment {
    color: #333333;
    font-size: 14px;
    font-weight: 500;
    padding: 15px 0;
    word-break: break-word;
}
.record-history-body:not(:last-child) {
    border-bottom: 1px solid #e2e2e2;
}
.record-history-body {
    margin-top: 20px;
}
</style>

<style lang="scss">
@import './table-style.scss';

.empty_wrapper {
    display: flex;
    gap: 5px;
    align-items: center;

    .el-button {
        // display: none;
        // border: none;
        background-color: #FFF1DF;
        color: #E28816;
        font-size: 12px;
        font-weight: 600;
        margin-left: 20px;
        height: 25px;
        padding: 0px 5px;
        align-items: center;
        line-height: 25px;
        .button-central {
            display: flex;
            align-items: center;
            padding: 0 5px;
            line-height: 24px;
            height: 25px;
        }
        i {
            font-style: normal;
            font-size: 20px;
            margin-right: 5px;
        }
    }
}
</style>